import { useState, useMemo, useCallback, useEffect } from 'react';
import { Popover, Button, DatePicker, Table, Space, Radio, message } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import { recommendWithdrawStatus } from '../../../../constants/report';
import { getRecommendWithdrawInfo, updateRecomendWithdrawStatus } from '../../../../service/report';
import './style.scss';

const columns = [{
  title: '项',
  dataIndex: 'item',
  key: 'item',
  width: '50%'
},{
  title: '值',
  dataIndex: 'value',
  key: 'value'
},{
  title: '参考值',
  dataIndex: 'demoValue',
  key: 'demoValue',
},]

const defaultNextTime = dayjs().add(30, 'day').format('YYYY-MM-DD');

const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current < moment().endOf('day');
};

// 撤案推荐
export default function RecommendWithdraw(props) {
  const [visible, setVisible] = useState(false);
  const [nextTimeByRecommend, setNextTimeByRecommend] = useState(moment(defaultNextTime));
  // 设置的案件撤案推荐状态
  const [withdrawState, setWithdrawState] = useState('waiting');
  const [recommendWithdrawRuleList, setRecommendWithdrawRuleList] = useState([]);
  const [loading, setLoading] = useState(false);

  const flowId = useMemo(() => props.flowId, [props.flowId]);
  // 案件撤案推荐状态
  const withdrawStatus = useMemo(() => props.status, [props.status]);

  // 状态label
  const statusText = useMemo(() => {
    const { status, nextTime } = props;
    if (status) {
      if (status === 'waiting') {
        return nextTime ? dayjs(nextTime).format('YYYY-MM-DD') : ''
      }
      return recommendWithdrawStatus[status] || ''
    }
    return ''
  }, [props.status, props.nextTime]);

  // 显示弹框
  const showModal = useCallback((event) => {
    if (withdrawStatus !== 'toDeal') {
      setVisible(false)
      return;
    }
    event.stopPropagation();
    setNextTimeByRecommend(moment(defaultNextTime));
    setVisible(true);
  }, [withdrawStatus]);

  // 显示/隐藏弹框回调
  const onVisibleChange = useCallback((_visible) => {
    if (withdrawStatus !== 'toDeal') {
      setVisible(false);
      return;
    }
    setVisible(_visible)
  }, [withdrawStatus]);

  const onSure = useCallback(() => {
    if (withdrawState === 'waiting' && !nextTimeByRecommend) {
      message.error('请选择下次推荐时间');
      return;
    }
    setLoading(true);
    updateRecomendWithdrawStatus({
      flowId: props.flowId,
      withdrawState,
      nextRecommendWithdraw: nextTimeByRecommend.format('YYYY-MM-DD')
    }).then(() => {
      setLoading(false);
      message.success('设置成功');
      setVisible(false);
      props.onSuccess && props.onSuccess(nextTimeByRecommend);
    }).catch(() => setLoading(false));

  }, [props, withdrawState, nextTimeByRecommend]);
  
  useEffect(() => {
    if (withdrawStatus === 'toDeal') {
      getRecommendWithdrawInfo({
        flowId: flowId
      }).then(({ result }) => setRecommendWithdrawRuleList(result.list)).catch(() => {})
    }
  }, [flowId]);
  
  return <Popover trigger="click" title="该案件为撤案推荐" visible={visible} overlayStyle={{ width: '500px' }} onVisibleChange={onVisibleChange} placement="topRight" content={<div className="recommend-withdraw-content">
    <Table columns={columns} dataSource={recommendWithdrawRuleList} bordered pagination={false} size="small" />
    <Radio.Group onChange={({ target }) => setWithdrawState(target.value)} value={withdrawState}>
      <Space direction="vertical">
        <Radio value="invalid" key="invalid">无效，不再推荐</Radio>
        <Radio value="waiting" key="waiting">暂无法判断有效性</Radio>
      </Space>
    </Radio.Group>
    <div className="next-time">
      <p>*建议下次推荐时间，届时若仍满足条件将会再做通知。</p>
      <DatePicker disabled={withdrawState !== 'waiting'} value={nextTimeByRecommend} size="small" onChange={setNextTimeByRecommend} disabledDate={disabledDate}/>
    </div>
    <div className="align-right" style={{ marginTop: 10 }}>
      <Button type="primary" size="small" onClick={onSure} loading={loading}>确定</Button>
    </div>
  </div>}>
    <Button type="text" onClick={showModal} disabled={withdrawStatus !== 'toDeal'}>撤案推荐({statusText})</Button>
  </Popover>
}